export let api_url;

const dev = "development";
const stage = "stage";
const system_ENV = process.env.REACT_APP_ENV;
if (system_ENV === dev) {
    api_url = 'https://dev-api.traqstock.com/';

}

else if (system_ENV === stage) {
    api_url = 'https://stg-api.traqstock.com/'
}

else {
    api_url = 'https://prod-api.traqstock.com/'
}
